const MyAthleteEntryNavLinks = {
  OME_LOADING: '/ome/loading',
  MY_ATHLETE_ENTRY: '/myathleteentry'
};

export default MyAthleteEntryNavLinks;